import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
require("../../sass/components/nounproject-plugin-navigation.sass");

import React from "react";
import PluginToolbar from "./plugin-toolbar";
import Icon from "./nounproject-ui-icon";

let Link = require("react-router").Link;

class NounProjectPluginNavigation extends React.Component {
    autocompleteSelectPrevious() {
        // action fired when user arrow keys to previous autocomplete selection
        let currentSelected,
            suggestions = JSON.parse(
                JSON.stringify(this.state.autocompleteTerms)
            );

        this.state.autocompleteTerms.forEach(suggestion => {
            if (suggestion.selected) {
                currentSelected = suggestion;

                // Find next term to select
                // previous is always the index of the current selected term - 1
                let currentIndex = this.state.autocompleteTerms.indexOf(
                        suggestion
                    ),
                    previous = currentIndex - 1;

                // if the nextIndex is less than total suggestions (5) set all selected to false
                if (previous >= 0) {
                    // updated previous selected property
                    suggestions[previous].selected = true;
                }

                // set unselect current term
                suggestions[currentIndex].selected = false;
            }
        });

        this.setState({
            autocompleteTerms: suggestions
        });
    }

    autocompleteSelectNext() {
        // action fired when user arrow keys to next autocomplete selection
        let currentSelected,
            suggestions = JSON.parse(
                JSON.stringify(this.state.autocompleteTerms)
            );

        this.state.autocompleteTerms.forEach(suggestion => {
            if (suggestion.selected) {
                currentSelected = suggestion;

                // Find next term to select
                // nextIndex is always the index of the current selected term +1
                let currentIndex = this.state.autocompleteTerms.indexOf(
                        suggestion
                    ),
                    nextIndex = currentIndex + 1;

                // if the nextIndex is greater than total suggestions (5) set nextIndex to just be the last term
                if (nextIndex === this.state.autocompleteTerms.length) {
                    nextIndex = this.state.autocompleteTerms.length - 1;
                }

                // updated selected properties
                suggestions[currentIndex].selected = false;
                suggestions[nextIndex].selected = true;
            }
        });

        // if no terms are selected select the first
        if (!currentSelected) {
            // clone suggestion state to modify it
            suggestions[0].selected = true;
        }

        this.setState({
            autocompleteTerms: suggestions
        });
    }

    clearSearchTerm() {
        // Always clear autocomplete
        this.setState({
            autocompleteTerms: [],
            showAutoComplete: false
        });
        if (!this.state.showAutoComplete) {
            // If autocomplete isn't showing, go back.
            this.goBack();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            autocompleteTerms: nextProps.autocompleteTerms
        });
    }

    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            clearSearchTerm: false,
            searchQuery: props.searchQuery === null ? "" : props.searchQuery,
            showAutoComplete: false
        };
    }

    getSuggestions(e) {
        // action to get autocomplete suggestions
        let searchTerm = e.target.value.replace(" ", "%20");

        this.setState({
            clearSearchTerm: false,
            searchQuery: searchTerm,
            showAutoComplete: true
        });

        if (searchTerm.length > 2) {
            this.props.fetchAutoCompleteTerms(searchTerm);
        } else {
            this.setState({
                autocompleteTerms: []
            });
        }
    }

    goBack() {
        hashHistory.push("search");
        this.props.setSearchTerm("");
        this.props.pluginIcons(1);
        this.setState({
            clearSearchTerm: true,
            searchQuery: "",
            autocompleteTerms: []
        });
        this.props.setPage("1");
        this.props.clearActiveIcon();
    }

    handleKeyup(event) {
        // if there are suggestions select them via up and down keys
        if (this.state.autocompleteTerms.length > 0) {
            let codes = {
                    up: 38,
                    down: 40,
                    right: 39,
                    left: 37,
                    enter: 13
                },
                keyCode = event.keyCode;

            // move selection up and down
            if (keyCode === codes.up) {
                this.autocompleteSelectPrevious();
            } else if (keyCode === codes.down) {
                this.autocompleteSelectNext();
            }
        }
    }

    navigateBack() {
        this.props.clearActiveIcon();
    }

    render() {
        let search = this.renderSearch();

        if (this.props.currentUser !== undefined) {
            return (
                <div className="quick-nav">
                    <PluginToolbar />
                    <div className="row">
                        {search}
                    </div>
                </div>
            );
        } else {
            return <div className="quick-nav-loading" />;
        }
    }

    renderSearch() {
        let clearSearch,
            searchIcon = null,
            suggestionContainer = this.renderSuggestionContainer(),
            searchQuery = this.state.searchQuery;

        if (this.state.searchQuery !== undefined) {
            searchQuery = this.state.searchQuery.replace("%20", " ");
        }

        if (this.state.clearSearchTerm) {
            searchQuery = "";
        }

        if (this.state.searchQuery || this.state.autocompleteTerms) {
            if (
                this.state.searchQuery ||
                this.state.autocompleteTerms.length > 0
            ) {
                clearSearch = (
                    <span
                        className="ui_deny"
                        onClick={this.clearSearchTerm.bind(this)}
                        title="Clear search"
                        style={{
                            position: "absolute",
                            right: "16px",
                            top: "14px",
                            color: "#6D6D6D",
                            cursor: "pointer"
                        }}
                    />
                );
            }
        }

        if (this.props.activeIcon) {
            searchIcon = (
                <label
                    className="search-box-icon left-arrow ui_left-arrow"
                    onClick={this.navigateBack.bind(this)}
                    title="Go back to search results"
                />
            );
        } else {
            searchIcon = (
                <label className="search-box-icon ui_search" htmlFor="search" />
            );
        }

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div
                    className="search-container"
                    style={{
                        maxWidth: "100%"
                    }}
                >
                    <form
                        action="/search/"
                        type="GET"
                        autoComplete="off"
                        spellCheck="false"
                        onSubmit={this.onSubmitSearch.bind(this)}
                        style={{ position: "relative" }}
                    >
                        {searchIcon}
                        <input
                            id="search"
                            type="search"
                            ref="search"
                            name="q"
                            placeholder="Search for anything"
                            autoComplete="off"
                            spellCheck="false"
                            style={{ fontSize: "18px" }}
                            value={searchQuery}
                            onKeyUp={this.handleKeyup.bind(this)}
                            onChange={this.getSuggestions.bind(this)}
                        />
                        {clearSearch}
                        <input
                            type="submit"
                            style={{
                                position: "absolute",
                                left: "-9999px",
                                width: "1px",
                                height: "1px"
                            }}
                            tabIndex="-1"
                        />
                    </form>
                    {suggestionContainer}
                </div>
            </div>
        );
    }

    renderSuggestionContainer() {
        let suggestionContainer,
            suggestionList = this.renderSuggestionList(),
            suggestionStyles = {
                fontSize: "18px",
                position: "absolute",
                width: "100%",
                border: "3px solid #F1F1F1",
                margin: "-3px 0 0 0",
                zIndex: "98"
            };

        suggestionContainer = (
            <div style={{ suggestionStyles }}>
                {suggestionList}
            </div>
        );

        if (this.state.autocompleteTerms) {
            if (this.state.autocompleteTerms.length < 3) {
                suggestionContainer = null;
            }
        }

        if (!this.state.showAutoComplete) {
            suggestionContainer = null;
        }

        return suggestionContainer;
    }

    renderSuggestionList() {
        // renders autocomplete suggestions
        let suggestionList = null;

        if (this.state.autocompleteTerms) {
            if (this.state.autocompleteTerms.length > 0) {
                suggestionList = [];

                this.state.autocompleteTerms.forEach(suggestion => {
                    suggestionList.push(
                        <li
                            className={suggestion.selected ? "active" : ""}
                            key={`suggestion.${suggestionList.length}`}
                            style={{
                                paddingLeft: "16px",
                                listStyle: "none"
                            }}
                        >
                            <a
                                href={`/search/?q=${suggestion.term}`}
                                title={gettext("Search for ") + suggestion.term}
                                style={{
                                    fontFamily:
                                        "Light-45,Helvetica Neue,Helvetica,Arial,sans-serif",
                                    display: "block",
                                    padding: "8px 0 8px 24px"
                                }}
                                onClick={this.onSelectedAutoCompleteTerm.bind(
                                    this,
                                    suggestion.term
                                )}
                            >
                                {suggestion.term}
                            </a>
                        </li>
                    );
                });
                suggestionList = (
                    <section
                        id="autocomplete"
                        className="plugin autocomplete-container autocomplete"
                        style={{
                            height: `${window.innerHeight}px`,
                            position: "fixed"
                        }}
                    >
                        {suggestionList}
                    </section>
                );
            }
        }

        return suggestionList;
    }

    onSelectedAutoCompleteTerm(query, e) {
        e.preventDefault();

        query = query.replace(" ", "%20");
        this.props.clearActiveIcon();
        this.props.setSearchTerm(query);
        hashHistory.push(`search/${query}`);
        this.setState({
            autocompleteTerms: [],
            showAutoComplete: false,
            searchQuery: query
        });
    }

    onSubmitSearch(e) {
        e.preventDefault();

        let currentSelected = false;

        this.state.autocompleteTerms.forEach(suggestion => {
            if (suggestion.selected) {
                currentSelected = true;

                this.props.clearActiveIcon();
                this.props.setSearchTerm(suggestion.term);
                hashHistory.push(`search/${suggestion.term}`);
                this.setState({
                    searchQuery: suggestion.term,
                    autocompleteTerms: [],
                    showAutoComplete: false
                });
            }
        });

        if (currentSelected === false) {
            this.props.clearActiveIcon();
            this.props.setSearchTerm(this.state.searchQuery);
            hashHistory.push(`search/${this.state.searchQuery}`);
            this.setState({ autocompleteTerms: [], showAutoComplete: false });
        }
    }
}

function mapStateToProps(state, ownProps) {
    let activeIcon,
        host,
        currentUser,
        page = state.plugin.page,
        searchQuery,
        autocompleteTerms = [];

    host = state.plugin.host;

    searchQuery = state.search.query;

    activeIcon = state.icons.active_icon;

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    if (state.search.autocompleteTerms !== undefined) {
        state.search.autocompleteTerms.suggestionKeys.forEach(key => {
            autocompleteTerms.push(state.search.autocompleteTerms[key]);
        });
    }

    return {
        autocompleteTerms,
        activeIcon,
        currentUser,
        page,
        host,
        searchQuery
    };
}

module.exports = connect(mapStateToProps, {
    fetchAutoCompleteTerms: actions.fetchAutoCompleteTerms,
    pluginIcons: actions.pluginIcons,
    clearActiveIcon: actions.clearActiveIcon,
    setPage: actions.setPage,
    setSearchTerm: actions.setSearchTerm
})(NounProjectPluginNavigation);
